import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './poste.routes';
import uuidv4  from 'uuid/v4';

export class PosteController {
  /*@ngInject*/
  constructor($http, $scope,$rootScope, $location, $stateParams, $filter, appConfig, toastr, Auth, Upload, Traduction) {
    var vm = this;
    $scope.clicked = false;
    vm.orderBy = "client";
    vm.reverseSort = false;
    vm.loading = true;

    fetchPoste()

    vm.createCategorie = function(){
      vm.data = {}
      vm.data.traductions = []
      vm.data.identifiants = _.map(vm.poste.listeIdentifiants, 'id')
      vm.data.standbyTimer = 40
      vm.data.autoEndTimer = 1
      $('#addCategorie').modal("show")
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    }

    $scope.$watch('vm.data.langues',function(newV){
      if(vm.data){
        if(vm.data.langues) {
          var langues  = _.filter(vm.availableLanguages, function(langue){return (vm.data.langues.includes(langue.id))})
          vm.data.traductions = angular.copy(_.map(langues, function(langue){return {id : langue.id, name : langue.name}}))
        } else {
          vm.data.traductions = []
        }
      }
    })

    vm.editCategorie = function(categorie){
      $location.path(`/categories/${categorie._id}`)
    }

    vm.addCategorie = function(form){
      if(form.$valid) {
        $scope.clicked = true;
        vm.errors = undefined;
        console.log(vm.data)
        vm.data.id = uuidv4()
        vm.data.posteId = $stateParams.id;
        vm.data.expiryDate = (vm.data.years * 365) + (vm.data.mounths * 30)
        vm.data.standbyTimer = vm.data.standbyTimer * 1000;
        vm.data.autoEndTimer = (vm.data.autoEndTimer * 1000) * 60 * 60;
        vm.data.identifiants = _.union(_.map(vm.listeIdentifiants, 'id'), vm.data.identifiants);
        uploadMass().then(response => {
          $http.get(`/api/postes/${vm.poste._id}`).then(function(response){
            vm.poste = response.data;
            $('#addCategorie').modal('hide');
            $scope.clicked = false;
            vm.data = {};
          })
        }).catch(err => {
          console.log(err);
          vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message};
          $scope.clicked = false;
        });
      }
    }

    function uploadMass () {
      return new Promise(function(resolve, reject){
        if(vm.data.image) {
          console.log(_.omit(vm.data, ['image']))
          Upload.upload({
              url: `/api/categories`,
              data: {file : vm.data.image, data : _.omit(vm.data, ['image'])}
          }).then(function (resp) {
            return resolve()
          }, function (resp) {
            return reject()
            $scope.clicked = false
            console.log('Error status: ' + resp.status);
          }, function (evt) {
            var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
            vm.uploadPercent = parseInt(90.0 * evt.loaded / evt.total);
          });
        } else {
          return resolve()
        }
      })
    };

    vm.copyCategorie = function(categorie) {
      vm.data = {}
      vm.categorieToCopy = angular.copy(categorie)
      $('#copyCategorie').modal('show')
    }

    vm.validateCopyCategorie = function() {
      vm.categorieToCopy.name = vm.data.name
      // vm.categorieToCopy._id = undefined
      $http.post('/api/categories/copy', vm.categorieToCopy).then(function(){
        $('#copyCategorie').modal('hide')
        location.reload();
      })
    }

    vm.deleteCategorie = function(categorie) {
      vm.categorieToDelete = categorie
      $('#deleteCategorie').modal('show')
    }

    vm.validateDeleteCategorie = function() {
      $scope.clicked = true
      $http.delete(`/api/categories/${vm.categorieToDelete._id}`, vm.poste).then(response => {
          vm.poste.Categories.splice(vm.poste.Categories.indexOf(vm.categorieToDelete), 1);
          $('#deleteCategorie').modal('hide')
          $scope.clicked = false
          vm.data = {}
      }).catch(err => {
        console.log(err)
        vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message}
        $scope.clicked = false
      }); 
    }

    vm.updateCategorie = function(categorie) {
      $scope.clicked = true
      vm.updatingCategorie = categorie
      $http.patch(`/api/categories/${categorie._id}`, {active : categorie.active}).then(response => {
          // toastr.success(`La categorie ${categorie.name} est ${categorie.active ? 'activée' : 'desactivée' }`, 'Poste mis à jour');
          toastr.success($filter('translate')('saved'), $filter('translate')('terminalUpdated'));
          $scope.clicked = false
          vm.updatingCategorie = undefined
      }).catch(err => {
        console.log(err)
        $scope.clicked = false
        vm.updatingCategorie = undefined
      }); 
    }

    vm.isUpdating = function(id) {
      if(vm.updatingCategorie && vm.updatingCategorie._id == id) return true
      else return false
    }

    $scope.$watch('vm.success', function(newV){
      if(newV == true) {
        setTimeout(function(){
          vm.success = false
          $scope.$apply()
        }, 3000)
      }
    })

    vm.createData = function(form){ 
      $("#addData").modal('show')
      vm.data = {}
      vm.data.traductions = angular.copy(_.map(vm.posteAvailableLanguages, function(langue){return {id : langue.id, name : langue.name}}))
      vm.data.commun = false
      vm.data.obligatoire = false
    }

    vm.editData = function(data, index) {
      vm.data = angular.copy(data)
      vm.data.index = index

      vm.data.traductions = _.filter(vm.data.traductions, function(trad){
        if(_.map(vm.posteAvailableLanguages, 'id').includes(trad.id)) return trad
      })
      _.forEach(vm.posteAvailableLanguages, function(languePoste){
        var langue = _.find(vm.poste.Site.langues, ['id', languePoste.id]);
        var currentLangue = _.find(vm.data.traductions, ['id', languePoste.id]);
        if(currentLangue && currentLangue.id == langue.id) currentLangue.name = langue.name;
        if(langue && !_.map(vm.data.traductions, 'id').includes(languePoste.id)) vm.data.traductions.push({name : langue.name, id : langue.id});
      });

      if(!vm.data.traductions) vm.data.traductions = angular.copy(_.map(vm.posteAvailableLanguages, function(langue){return {id : langue.id, name : langue.name}}))
      if(vm.data.index >= 3)$('#addData').modal('show')
      else $('#editData').modal('show')
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    }

    vm.addData = function(form){
      if(form.$valid) {
        vm.errors = undefined
        $scope.clicked = true
        if(!Array.isArray(vm.poste.listeIdentifiants)) vm.poste.listeIdentifiants = []
        if(!vm.data.id) vm.data.id = uuidv4()
        if(vm.data.index != undefined) vm.poste.listeIdentifiants[vm.data.index] = vm.data
        else vm.poste.listeIdentifiants.push(vm.data)
        $http.patch(`/api/postes/${vm.poste._id}?newId=${vm.data.id}`, vm.poste).then(response => {
          $http.get(`/api/postes/${vm.poste._id}`).then(response => {
              vm.poste = response.data;
              $('#addData').modal('hide')
              $('#editData').modal('hide')
              $scope.clicked = false
              vm.data = {}
              refreshIdentifiants()
            });
        }).catch(err => {
          console.log(err)
          vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message}
          $scope.clicked = false
        });
      }
    }

    vm.deleteData = function(data, index) {
      vm.dataToDelete = data
      vm.dataToDelete.index = index
      $('#deleteData').modal('show')
    }

    vm.validateDelete = function() {
      $scope.clicked = true
      vm.poste.listeIdentifiants.splice(vm.poste.listeIdentifiants.indexOf(vm.dataToDelete), 1);
      $http.patch(`/api/postes/${vm.poste._id}`, vm.poste).then(response => {
        $http.get(`/api/postes/${vm.poste._id}`).then(response => {
          vm.poste = response.data;
          $('#deleteData').modal('hide')
          $scope.clicked = false
          vm.data = {}
          refreshIdentifiants()
        });
      }).catch(err => {
        console.log(err)
        vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message}
        $scope.clicked = false
      }); 
    }

    vm.save = function() {
      $scope.clicked = true
      $http.patch(`/api/postes/${vm.poste._id}`, vm.poste).then(response => {
        // toastr.success('Le poste a bien été mis à jour.', 'Poste mis à jour');
        toastr.success($filter('translate')('saved'), $filter('translate')('terminalUpdated'));
        $scope.clicked = false
        updateLangue()
      }).catch(err => {
        console.log(err)
        vm.errors = {errorTitle : Traduction.selectedLanguage.dictionnary["error"], errorMessage : err.data.message}
        $scope.clicked = false
      }); 
    }

    $scope.$watch('vm.data.impose', function () {
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    })

    function updateLangue(){
      vm.posteAvailableLanguages = []
      _.forEach(_.map(vm.poste.Site.langues, 'id'), function(langueSite){
        _.forEach(vm.poste.langues, function(languePoste){
          if(langueSite == languePoste) vm.posteAvailableLanguages.push(_.find(vm.poste.Site.langues, ['id', languePoste]))
        })
      })
    }


    function fetchPoste(){
      Auth.getCurrentUser().then(function(user){
        vm.user = user
        vm.availableCategories = _.map(vm.user.Categories, '_id')
        $http.get('/api/postes/' + $stateParams.id).then(response => {
          $http.get('/api/users/get/contacts').then(users => {
            vm.poste = response.data;
            vm.poste.siteId = [vm.poste.Site._id];
            vm.availableLanguages = vm.poste.Site.langues;
            vm.contacts = users.data;
            _.map(vm.poste.Site.Users, function (user) {
              console.log(!_.map(vm.contacts, 'email').includes(user.email))
              if(!_.map(vm.contacts, 'email').includes(user.email)) vm.contacts.push(user)
            })
            $rootScope.siteId = vm.poste.Site._id
            refreshIdentifiants()
            updateLangue()
            setTimeout(function() {
              $('.selectpicker').selectpicker('refresh');
            }, 10);
            vm.loading = false
          });
        });
      })
    }

    function refreshIdentifiants() {
      vm.listeIdentifiants = _.filter(vm.poste.listeIdentifiants, {'commun' : true})
      vm.poste.availableIdentifiants = _.filter(vm.poste.listeIdentifiants, {'commun' : false})
    }


    /*$http.get('/api/postes/' + $stateParams.id).then(response => {
      vm.poste = response.data;
      vm.poste.siteId = [vm.poste.Site._id]
      console.log(vm.poste)
      vm.availableLanguages = vm.poste.Site.langues
      $rootScope.siteId = vm.poste.Site._id
      updateLangue()
      setTimeout(function() {
        $('.selectpicker').selectpicker('refresh');
      }, 10);
    });*/
  }
}

export default angular.module('aperamApp.poste', [uiRouter])
  .config(routing)
  .component('poste', {
    template: require('./poste.html'),
    controller: PosteController,
    controllerAs:'vm'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/poste/poste.component.js